"use strict";

var PropTypes = require("prop-types");

var classNames = require("classnames");
var LoggerInstance = require("js-logger").get("ChargeToday");
var React = require("react");

var CheckoutActions = require("./CheckoutActions");
var CheckoutStore = require("./CheckoutStore");

class ChargeToday extends React.Component {
	constructor(props) {
		super(props);

		this.state = this.getStateFromStore(props);

		this._onChange = this._onChange.bind(this);
	}

	handleChange(event) {
		CheckoutActions.setDonationChargeToday(this.props.cartItemId, event.currentTarget.checked);
		if (!this.props.isDesignMode) {
			CheckoutActions.updateDonation(this.props.cartItemId);
		}
	}

	getStateFromStore(props) {
		return {
			isChargeToday: CheckoutStore.getDonationChargeToday((props || this.props).cartItemId)
		};
	}

	_onChange() {
		this.setState(this.getStateFromStore());
	}

	componentDidMount() {
		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentLoaded(this);
		}
		CheckoutStore.addChangeListener(this._onChange);
	}

	componentWillUnmount() {
		CheckoutStore.removeChangeListener(this._onChange);

		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentUnloaded(this);
			CheckoutActions.setDonationChargeToday(this.props.cartItemId, false);
		}
	}

	render() {
		var startDate = CheckoutStore.getDonationStartDate(this.props.cartItemId);
		var recurringStartsToday = startDate.isSame(new Date(), "day");
		var isChargeToday = this.state.isChargeToday || recurringStartsToday;
		var isChargeTodayRequired = CheckoutStore.getIsDonationChargeTodayRequired(this.props.cartItemId);
		var isDisabled = !this.props.isDesignMode && (
			isChargeTodayRequired ||
			CheckoutStore.getDonationFrequency(this.props.cartItemId) === "O" ||
			recurringStartsToday
		);

		return (
			<span
				data-react-component-name="ChargeToday"
				data-react-component-category="DonationCartItemComponents"
				data-component-id={this.props.dataComponentId}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
			>
				<input
					type="checkbox"
					className={classNames(this.props.className, {disabled: isDisabled})}
					data-override-classes={this.props.className}
					checked={isChargeToday}
					onChange={this.handleChange.bind(this)}
					disabled={isDisabled}
				/>
			</span>
		);
	}
}

ChargeToday.defaultProps = {};

ChargeToday.propTypes = {
	className: PropTypes.string,
	isDesignMode: PropTypes.bool,
	cartItemId: PropTypes.string,
	theme: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string
};

module.exports = ChargeToday;
